var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetirementScore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#D6FFDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9776 20.1567C24.9776 21.2874 24.061 22.204 22.9303 22.204C21.7996 22.204 20.8828 21.2874 20.8828 20.1567C20.8828 19.026 21.7996 18.1094 22.9303 18.1094C24.061 18.1094 24.9776 19.026 24.9776 20.1567Z",
    fill: "url(#paint0_linear_423_418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9471 23.4891C38.7751 23.4187 38.596 23.4027 38.4242 23.4255H35.6204C35.4488 23.4027 35.2696 23.4186 35.0974 23.4891C33.0324 24.338 32.2413 27.8132 31.9404 30.0957C31.8904 30.1709 31.8521 30.2545 31.8458 30.3511C31.7969 31.1004 31.4696 32.7411 30.7705 33.0284C30.7508 33.0364 30.7337 33.0477 30.7155 33.0577H29.6319C29.6139 33.0477 29.5965 33.0364 29.5769 33.0284C28.881 32.7423 28.5517 31.1007 28.501 30.3507C28.4866 30.1316 28.3391 29.9532 28.1449 29.8845C27.6105 20.2753 17.9004 20.7645 17.7033 30.077C17.6917 30.6423 18.1401 31.1102 18.7055 31.1221C18.7125 31.1223 18.72 31.1223 18.7275 31.1223C19.2828 31.1223 19.7385 30.6782 19.7507 30.1204C19.7514 30.0857 19.8505 27.5584 21.0046 26.0314L19.5053 34.2888H20.4491V40.8282C20.4491 41.3936 20.9075 41.8518 21.4727 41.8518C22.038 41.8518 22.4963 41.3935 22.4963 40.8282V34.2888H23.3601V40.8282C23.3601 41.3936 23.8184 41.8518 24.3836 41.8518C24.949 41.8518 25.4072 41.3935 25.4072 40.8282L25.4074 34.2888H26.3512L24.8483 26.0113C26.0171 27.5313 26.1047 30.0681 26.1062 30.1213C26.1182 30.6786 26.574 31.122 27.1289 31.122C27.1364 31.122 27.1439 31.122 27.1508 31.1219C27.2787 31.1192 27.3991 31.0903 27.511 31.0453C27.6391 31.8594 27.9762 33.2187 28.841 33.8271V41.3187C28.841 41.613 29.0796 41.8518 29.3741 41.8518C29.6683 41.8518 29.9071 41.6132 29.9071 41.3187V37.3214H30.4401V41.3187C30.4401 41.613 30.6787 41.8518 30.973 41.8518C31.2672 41.8518 31.506 41.6132 31.506 41.3187V33.8266C31.8347 33.5954 32.0853 33.2538 32.2794 32.8761C32.4156 32.955 32.5697 33.0073 32.7378 33.0159C32.7553 33.0166 32.7728 33.0171 32.7903 33.0171C33.3321 33.0171 33.784 32.592 33.8115 32.0447C33.8744 30.7948 34.1042 29.24 34.4635 27.9413V31.1007C34.4635 31.1014 34.4633 31.1021 34.4633 31.1029V40.8277C34.4633 41.393 34.9217 41.8512 35.4869 41.8512C36.0522 41.8512 36.5105 41.3929 36.5105 40.8277L36.5103 32.6384H37.5339V40.8277C37.5339 41.393 37.9923 41.8512 38.5575 41.8512C39.1228 41.8512 39.5811 41.3929 39.5811 40.8277L39.5814 32.6384H39.5816V27.917C39.9461 29.2394 40.1711 30.8213 40.2338 32.0451C40.2613 32.5919 40.7136 33.0167 41.255 33.0167C41.2725 33.0167 41.29 33.0161 41.3081 33.0154C41.8724 32.9867 42.3066 32.5063 42.2783 31.9417C42.2177 30.7338 41.7718 24.6498 38.9472 23.4887L38.9471 23.4891Z",
    fill: "url(#paint1_linear_423_418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0712 20.1567C39.0712 21.2874 38.1546 22.204 37.0239 22.204C35.8932 22.204 34.9766 21.2874 34.9766 20.1567C34.9766 19.026 35.8932 18.1094 37.0239 18.1094C38.1546 18.1094 39.0712 19.026 39.0712 20.1567Z",
    fill: "url(#paint2_linear_423_418)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2413 31.4721C31.2413 32.0609 30.764 32.538 30.1752 32.538C29.5867 32.538 29.1094 32.0608 29.1094 31.4721C29.1094 30.8834 29.5867 30.4062 30.1752 30.4062C30.764 30.4062 31.2413 30.8834 31.2413 31.4721Z",
    fill: "url(#paint3_linear_423_418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_423_418",
    x1: 24.9772,
    y1: 20.1374,
    x2: 20.6702,
    y2: 20.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_423_418",
    x1: 42.2772,
    y1: 32.2778,
    x2: 16.427,
    y2: 32.2778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_423_418",
    x1: 39.0708,
    y1: 20.1374,
    x2: 34.764,
    y2: 20.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_423_418",
    x1: 31.2411,
    y1: 31.4621,
    x2: 28.9987,
    y2: 31.4621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementScore);
export default __webpack_public_path__ + "static/media/retirementScore.aa408f7370f9714fbc28787658ee86c3.svg";
export { ForwardRef as ReactComponent };